import React, { useState } from "react";

import styles from "./SampleCloseForm.module.scss";

import { SubmitHandler, useForm } from "react-hook-form";
import { ICloseFormInput, SampleProps } from "../../types/sample";
import { POST } from "../../services/axios.service";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";

type Props = {
  sample: SampleProps;
};

const SampleCloseForm = ({ sample }: Props) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<ICloseFormInput>();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestError, setRequestError] = useState<string | null>(null);

  const onSubmit: SubmitHandler<ICloseFormInput> = async (data) => {
    setIsLoading(true);
    setRequestError(null);

    try {
      if (data && data.delivered_qty && sample && sample.id) {
        const requestObj = {
          sample_id: sample.id,
          delivered_qty: data.delivered_qty,
          amount: data.amount,
        };

        await POST("/v1/worker/sample-close", requestObj)
          .then(async (response: any) => {
            if (response.data.status === "success") {
              const downloadLink = response.data.data.download_link;
              try {
                const newWindow = window.open(downloadLink, "_blank");
                if (
                  !newWindow ||
                  newWindow.closed ||
                  typeof newWindow.closed == "undefined"
                ) {
                  throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
                }
              } catch (e) {
                window.location.href = downloadLink;
              }
              await reset();
              navigate(route.openSample);
            } else {
              setRequestError(response.data.message);
            }
          })
          .catch((error: any) => {
            setRequestError(error.data.message);
          });
      } else {
        setRequestError("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
      }
    } catch (error) {
      setRequestError("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }

    setIsLoading(false);
  };

  return (
    <div className={styles.SampleCloseForm}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {requestError !== null && (
          <span className="text-red-500 text-center mt-8">{requestError}</span>
        )}

        <div className="mt-6">
          <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
            <input
              className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
              type="number"
              step="any"
              pattern="[0-9]+(\.[0-9]+)?"
              placeholder="ડિલિવર કરેલ QTY દાખલ કરો"
              {...register("delivered_qty", {
                required: true,
                min: 0,
              })}
              onFocus={(e) =>
                e.target.addEventListener(
                  "wheel",
                  function (e) {
                    e.preventDefault();
                  },
                  { passive: false }
                )
              }
            />
          </div>
          {errors.delivered_qty && (
            <span className="text-red-500">ડિલિવર કરેલ QTY દાખલ કરો</span>
          )}

          <div className="bg-gradient-to-r mt-6 from-primary-1 to-primary-2 h-16 w-full relative rounded">
            <input
              className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
              type="number"
              step="any"
              pattern="[0-9]+(\.[0-9]+)?"
              placeholder="અમાઉન્ટ દાખલ કરો"
              {...register("amount", {
                required: true,
                min: 0,
              })}
              onFocus={(e) =>
                e.target.addEventListener(
                  "wheel",
                  function (e) {
                    e.preventDefault();
                  },
                  { passive: false }
                )
              }
            />
          </div>
          {errors.amount && (
            <span className="text-red-500">અમાઉન્ટ દાખલ કરો</span>
          )}

          <div className="w-full flex">
            <button
              className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "રાહ જુઓ..." : "પુરુ કરો"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default SampleCloseForm;
